import useTranslation from 'next-translate/useTranslation'

import IconContainer from './icons/IconContainer'
const LiquidationConditions = function ({
  collateral,
  currentPrice,
  liquidationPrice
}) {
  const { t } = useTranslation()

  return liquidationPrice && currentPrice ? (
    <div className="bg-blue-secondary rounded-lg px-4 py-3 text-center">
      <h2 className="mb-2 font-semibold">
        {t('liquidation-conditions.title')}
      </h2>
      <p className="mb-3 text-xs leading-5">
        {t('liquidation-conditions.description', {
          price: liquidationPrice,
          symbol: collateral.symbol
        })}
      </p>
      <p>
        <span className="bg-gray-tertiary/40 inline-flex items-center gap-2 whitespace-nowrap rounded-lg px-7 py-2 text-xs leading-5">
          {t('liquidation-conditions.current-price')}{' '}
          <IconContainer name={collateral.symbol} /> {currentPrice}
        </span>
      </p>
    </div>
  ) : null
}

export default LiquidationConditions
